import { CookiesProvider } from 'react-cookie'

export const withCookies = (component) => () => (
  <CookiesProvider>{component()}</CookiesProvider>
)
